export class ConsoleMessage {
  print() {
    console.log(`
Thanks for checking out my website!

You can contact me at billnreed@gmail.com if you'd like to get in touch.
    `);
  }
}
